import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.activeIndex = -1
  }

  onKeydown(event) {
    const { key } = event
    const items = this.items

    if (!items.length) return

    if (key === "ArrowDown") {
      event.preventDefault()
      this.move(1)
    } else if (key === "ArrowUp") {
      event.preventDefault()
      this.move(-1)
    } else if (key === "Enter" && this.activeIndex >= 0) {
      event.preventDefault()
      this.selectPosition(this.activeIndex)
      this.clearActive()
    } else if (key === "Escape") {
      this.clearActive()
    }
  }

  move(delta) {
    const items = this.items
    const max = items.length
    const current = this.activeIndex
    const nextIndex = (current + delta + max) % max
    this.clearActive()

    this.activeIndex = nextIndex
    const el = items[this.activeIndex]
    el.classList.add("active")
    el.setAttribute("aria-selected", "true")
    el.scrollIntoView({ block: "nearest" })
  }

  selectPosition(index) {
    const el = this.items[index]
    el.click()
  }

  clearActive() {
    this.items.forEach(el => {
      el.classList.remove("active")
      el.removeAttribute("aria-selected")
    })
    this.activeIndex = -1
  }

  get items() {
    return this.itemTargets.filter(target => !target.classList.contains("hidden"))
  }
}
